/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import { ApiClientFactory } from '../libs';
import * as utils from './utils';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'BindApi';

/**
 * そのコンポーネントがAPI連携することを宣言します
 *
 * 下記のパラメータを指定できます。
 * name: APIClientインスタンス生成用のファクトリ名を指定します。
 * factory: APIClientインスタンス生成用のファクトリを指定します。
 * resetBefore: 実行前に未完了の通信を全てキャンセルする処理を指定します。
 *
 * コンポーネントに下記を追加します。
 * this.$_sas.$api: APIClientインスタンス
 *
 * a)factoryまたはb)nameで指定されたファクトリを利用してAPIClient
 * インスタンスを生成します。
 *
 * 両方指定されている場合は、a)で指定されたファクトリを利用します。
 * 未指定の場合は、デフォルトのAPIClientを利用します。
 *
 * ファクトリはAPIClientを返却する関数である必要があります。
 */
export default function BindApi (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(
      DECORATOR_NAME, {
        name: { type: 'string', mustBe: ['not empty'] },
        factory: { type: 'function' },
        createOptions: { type: 'object' },
        resetBefore: { type: 'array', shouldBe: ['not empty'] }
      },
      decoratorOptions
    );
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // オプション値取得
    const name = decoratorOptions.name || null;
    const factory = decoratorOptions.factory || null;
    const createOptions = decoratorOptions.createOptions || {};
    const resetBefore = decoratorOptions.resetBefore || [];

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      // デコレータ管理用変数初期化
      this.$_sas = this.$_sas || {};
      this.$_sas.$api = factory
        ? factory(this, createOptions)
        : ApiClientFactory.create(name, this, createOptions);
    });

    // 関数をラップして事前処理を追加する
    utils.wrapMethods(options.methods, resetBefore, function () {
      this.$_sas.$api.cancel();
    });

    // destroyed時の処理を追加
    const destroyed = options.destroyed || function () { };
    options.destroyed = utils.injectAfter(destroyed, function () {
      // デコレータ管理用変数破棄
      if (this.$_sas) {
        if (this.$_sas.$api) {
          this.$_sas.$api.destroy();
          delete this.$_sas.$api;
        }
        if (Object.keys(this.$_sas).length === 0) {
          delete this.$_sas;
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/BindApi.js